export interface IButton {
  enabled: boolean;
  type: ButtonTypeEnum;
  callback?: any;
  hideLoader?: boolean;
  resetLoader?: () => void;
}

export enum ButtonTypeEnum {
  CHECK_ANSWER = "Check_Answer",
  CONTINUE = "Continue",
  SUBMIT = "Submit",
  TRY_AGAIN = "Try Again"
}
